import script from "./TestManager.vue?vue&type=script&setup=true&lang=js"
export * from "./TestManager.vue?vue&type=script&setup=true&lang=js"

import "./TestManager.vue?vue&type=style&index=0&id=50f81ee9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f81ee9"]])

export default __exports__